export default (linkId: string, additionalData?: string) => {
  const linkSuffix = linkId + (additionalData ? `-${additionalData}` : '');
  return `survey-surveyItem-${linkSuffix}`;
};
